export const ITEMS_COUNT = 100000;
export const ITEMS_SMALL_COUNT = 100;
